import { isAxiosError } from 'axios';
import { apiClient } from '@/axios';
import { Endpoints } from '@/enums';
import { ContainerRelease } from './types';

type GetContainerReleaseResponse = {
  state: number;
  value: ContainerRelease[];
};

export const getContainerReleaseList = async (): Promise<
  ContainerRelease[]
> => {
  try {
    const res = await apiClient.post<GetContainerReleaseResponse>(
      Endpoints.LiberacionImport,
      {}
    );
    return Array.isArray(res?.data?.value) ? res.data.value : [];
  } catch (error) {
    if (isAxiosError(error)) {
      throw new Error(error.message);
    }
    throw error;
  }
};
